import React, { useState, useEffect, Fragment } from "react";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import i18n from '../i18n';
import Navbar from "../Navbar";
import Footer from "../Footer";
import Aos from 'aos';
import 'aos/dist/aos.css';
const { config } = require('../api/api');

function DhofarMotorinsuranceQuote() {

  const base_url = config.baseURL;

  const { t } = useTranslation();

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  const [loading, setLoading] = useState(false);

  const changeLanguage = (lng) => {

    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (1 * 60 * 60 * 1000));

    Cookies.set('langData', lng, { expires: expiryDate });

    i18n.changeLanguage(lng);
  };

  const [isEmailActive, setEmailActive] = useState(false);
  const [isMobilenoActive, setMoblienoActive] = useState(false);
  const [isWhatappActive, setWhatappActive] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);

   const [vendorKey,setVendorkey]=useState(null);
   const [quoteDetails,setQuoteDetails]=useState(null);
   const [vehicleDetails,setVehicleDetails]=useState(null);
   const [insuredDetails,setInsuredDetails]=useState(null);
   const [transactionDetails,setTransactionDetails]=useState(null)



  const [insData, setData] = useState(false);

  useEffect(() => {
    // debugger
    const storeddata = sessionStorage.getItem('motorinsurancePlan');
    if (storeddata !== undefined && storeddata !== null) {
      const storeddt = JSON.parse(storeddata);
      setData(storeddt);
    }
    else {
      window.location.href = '/dhofar-motorinsurance';
    }
  }, []);

    useEffect(() => {
  
      const postvData = { organization_name: "Superjet" };
      debugger
  
      if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
  
        debugger
        fetch(base_url + '/create_organization', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(postvData),
        })
          .then(response => response.json())
          .then(data => {
            setVendorkey(data.result[0].vendor_key);
          })
          .catch(error => {
            console.error('Error posting data:', error);
          });
  
  
      }
    }, [vendorKey]);

  // Function to update HTML dir attribute based on language
  const updateHtmlDirAttribute = () => {
    document.documentElement.dir = i18n.dir(); // Set document direction
  };

  // Update HTML dir attribute when component mounts and language changes
  useEffect(() => {
    updateHtmlDirAttribute();
  }, [i18n.language]);

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);


  const handleback = async (event) => {
    event.preventDefault();

    window.location.href = '/dhofar-motor-thirdparty'
  };

  const handlesuccess = async (event) => {
    event.preventDefault();
    window.location.href = '/dhofar-motor-success'
  };
  const styles = {
    column: {
      flex: '1',
      padding: '0 10px',
    }
  };

  useEffect(()=>{
const getQuote=async()=>{
  // getQuoteInput session name 
  const get_quote_input =sessionStorage.getItem("getQuoteInput");
  if(get_quote_input){
//   const req_data={
//     civilId:"",
//     plateNo: "",
//     registrationMark:"",
//     srcBusId: "BOT",
//     txnTyp:"Q",
//     mobileNo:"",
//     policyNo:"107/0502/2025/Q/000742",
//     quoteNo:""

// }
const req_data=JSON.parse(get_quote_input);
  const response=await fetch(base_url+"/search_quote",{
    method:"POST",
    headers:{
      "authorization":"Bearer "+vendorKey,
      "Content-Type":"application/json"
    },
    body: JSON.stringify(req_data)
  }
  );
  if(!response.ok){
    console.log("Err at search quote API "+response.statusText);
  }
  else{
      const data =await response.json();
      if(data.message==="success"){
        setQuoteDetails(data.result);
        setVehicleDetails(data.result.vehicleDetails);
        setInsuredDetails(data.result.insuredDetails);
        setTransactionDetails(data.result.transactionDetails);
      }
  }
}

}
  if(vendorKey){
    getQuote();
  }

  },[vendorKey])

  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h5 className="abt-txt my-3">{(lnstr === 'en') ? 'Details Page' : 'تحميل السياسة\n'}</h5>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={2}></Col>

            <Col md={8} className="myforms my-5" data-aos='fade-up'>
              <div class="card">
                <div class="card-body">
                  <h4 style={{ textAlign: "center" }}><strong>Vehicle Details</strong></h4><hr />
                  <div>

                    <div className="d-flex justify-content-between my-3 colmds-4 card m-0">
                      <div className="d-flex justify-content-between my-1">
                        <div>
                          <h3><strong>{vehicleDetails?.make}</strong></h3>
                          <p><strong>{vehicleDetails?.modelYear}</strong></p>
                        </div>
                        <div>
                          <button>{vehicleDetails?.vehRegNo} {vehicleDetails?.vehRegLOC}</button>
                        </div>

                      </div>

                    </div>

                  </div>
                  <div className="row">
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <span>Chassis Number</span>
                      <div className="mt-2"><h6><strong>{vehicleDetails?.chasisNo}</strong></h6></div>
                    </div>
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <span>Body Type</span>
                      <div className="mt-2"><h6><strong>{vehicleDetails?.vehBody}</strong></h6></div>
                    </div>
                    <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <span>Usage Type</span>
                      <div className="mt-2"><h6><strong>{vehicleDetails?.usage}</strong></h6></div>
                    </div>
                    {/* <div className="col-lg-3 col-md-12 col-sm-12 col-12">
                      <span>Vechicle Value</span>
                      <div><h6><strong>RO 15,000</strong></h6></div>
                    </div> */}
                  </div>
                  <hr />
                  <h4 style={{ textAlign: 'center' }}><strong>Insured</strong></h4><hr />
                  <div className="row">
                    <div className="col-lg-5 " >
                      <span>Insured Name</span>
                      <div className="mt-2"><h6><strong>{insuredDetails?.insureFullName}</strong></h6></div>
                    </div>
                    <div className="col-lg-4">
                      <span>Civil Id</span>
                      <div className="mt-2"><h6><strong>{insuredDetails?.insuredLicNo}</strong></h6></div>
                    </div>
                    <div className="col-lg-3">
                      <span>Age</span>
                      <div className="mt-2"><h6><strong>{insuredDetails?.insuredAge}</strong></h6></div>
                    </div>
                  </div>
                  <hr />
                  {/* <h4 style={{ textAlign: 'center' }}><strong>Communication Preferences</strong></h4><hr /> */}

                  {/* <div class="d-flex justify-content-between">
                    <div className="row">
                      <div className="col-12 col-md-4 mb-3">
                        <input type="checkbox" checked={isMobilenoActive} style={{ marginRight: '8px' }} onChange={(e) => setMoblienoActive(e.target.checked)} />Mobile No        <div><input type='num' readOnly placeholder="+968 9678 3415"
                          disabled={!isMobilenoActive}
                          style={{
                            padding: "0.5rem",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: !isMobilenoActive ? "#f5f5f5" : "#fff",
                            filter: !isMobilenoActive ? "blur(0.5px)" : "none",
                            pointerEvents: !isMobilenoActive ? "none" : "auto",
                          }}
                        ></input></div>
                      </div>
                      <div className="col-12 col-md-4 mb-3">
                        <input
                          type="checkbox"
                          checked={isWhatappActive}
                          style={{ marginRight: '8px' }}
                          onChange={(e) => setWhatappActive(e.target.checked)}
                        />Whatapp Number
                        <div>  <input
                          type="num"
                          placeholder="+968 9678 3415"
                          disabled={!isWhatappActive}
                          readOnly
                          style={{
                            padding: "0.5rem",
                            border: "2px solid #ccc",
                            borderRadius: "4px",
                            backgroundColor: !isWhatappActive ? "#f5f5f5" : "#fff",
                            filter: !isWhatappActive ? "blur(0.5px)" : "none",
                            pointerEvents: !isWhatappActive ? "none" : "auto",
                          }}
                        /></div>
                      </div>
                      <div className="col-12 col-md-4 mb-3">
                        <input
                          type="checkbox"
                          checked={isEmailActive}
                          style={{ marginRight: "8px" }}
                          onChange={(e) => setEmailActive(e.target.checked)}
                        />Email
                        <div>
                          <input
                            type="email"
                            placeholder="mail@gmail.com"
                            disabled={!isEmailActive}
                            readOnly
                            style={{
                              padding: "0.5rem",
                              border: "2px solid #ccc",
                              borderRadius: "4px",
                              backgroundColor: !isEmailActive ? "#f5f5f5" : "#fff",
                              filter: !isEmailActive ? "blur(0.5px)" : "none",
                              pointerEvents: !isEmailActive ? "none" : "auto",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {/* <hr /> */}
                  <h4 style={{ textAlign: 'center' }}><strong>Quote</strong></h4><hr />

                  <div className="row">
                    <div className="col-lg-4">
                      <span>Quote No</span>
                      <div className="mt-2"><h6><strong>{transactionDetails?.quoteNo}</strong></h6></div>
                    </div>
                    <div className="col-lg-4">
                      <span>Cover From Date</span>
                      <div className="mt-2"><h6><strong>{quoteDetails?.effectiveDt}</strong></h6></div>
                    </div>
                    <div className="col-lg-4">
                      <span>Cover To Date</span>
                      <div className="mt-2"><h6><strong>{quoteDetails?.expirationDt}</strong></h6></div>
                    </div>
                    <div className="col-lg-5" >
                      <span>Product</span>
                      <div className="mt-2"><h6><strong>{quoteDetails?.prodId}</strong></h6></div>
                    </div>
                    <div className="col-lg-5">
                      <span>Plan</span>
                      <div className="mt-2"><h6><strong>{quoteDetails?.planSelection}</strong></h6></div>
                    </div>
                
                  <div className="col-lg-12">
                      <span>Obtained Cover</span>
                      <div className="mt-2"><h6><strong>{quoteDetails?.obtainedCvr}</strong></h6></div>
                    </div>
                    </div>

                  <div className="d-flex justify-content-between my-3 colmds-4 card m-0">
                    <div className="d-flex justify-content-between my-1">
                      <div>
                        <h6><strong>NET PREMIUM (Including VAT & all other taxes)</strong></h6>
                        <h3><strong>OMR {quoteDetails?.premiumAmt}</strong></h3>
                      </div>
                      <div>
                        <button type='submit' onClick={handlesuccess} style={{
                          backgroundColor: isHovered1 ? '#0b8ba8' : '#33d0f2',
                          transition: 'background-color 0.3s ease',
                        }} onMouseEnter={() => setIsHovered1(true)} onMouseLeave={() => setIsHovered1(false)} >PAY PREMIUM</button>
                      </div>

                    </div>

                  </div>

                </div>
              </div>

              <button type='button' onClick={handleback} className="rounded-pill text-white my-1 py-1 px-4" style={{
                backgroundColor: isHovered ? '#0b8ba8' : '#33d0f2',
                transition: 'background-color 0.3s ease',
                position: 'absolute',
                right: '20px',
                marginTop: '10px'
              }} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} >BACK</button>



            </Col>

            <Col md={2}></Col>

          </div>


        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default DhofarMotorinsuranceQuote;